import React, { useState, useEffect } from "react";
import { Edit } from "lucide-react";
import { toast } from "react-hot-toast";
import { evaluationAPI } from "../../../services/AdminPortal/evaluationAPI";

const EvaluationScoreBoard = ({ loanId, application }) => {
  console.log(application,"kkkkkkkkkk")
  const customerId = application?.user?._id;
  const [evaluationData, setEvaluationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const defaultData = {
    incomeAnalysis: { score: "", monthlyIncome: "", incomeStability: "" },
    legalAnalysis: { score: "", itrs: "", businessLicences: "" },
    businessAnalysis: {
      score: "",
      businessAge: "",
      businessType: "",
      incomeByPeriod: "",
    },
    propertyAnalysis: {
      score: "",
      propertyValue: "",
      ownership: "",
      propertyType: "",
    },
  };

  const [formData, setFormData] = useState(defaultData);

  // Format helpers
  const formatScore = (value) =>
    !value || value === "NA" ? "-/100" : `${value}/100`;
  const formatCurrency = (value) =>
    !value || value === "NA" ? "-" : `₹${value}`;
  const formatText = (value) => (!value || value === "NA" ? "-" : value);

  // ✅ Fetch evaluation data
  useEffect(() => {
    const fetchData = async () => {
      if (!loanId) return;
      try {
        setLoading(true);
        const res = await evaluationAPI.getEvaluationByLoanId(loanId);

        if (res.success && res.data) {
          // ✅ Merge only known analysis fields
          const cleaned = {
            incomeAnalysis: res.data.incomeAnalysis || defaultData.incomeAnalysis,
            legalAnalysis: res.data.legalAnalysis || defaultData.legalAnalysis,
            businessAnalysis: res.data.businessAnalysis || defaultData.businessAnalysis,
            propertyAnalysis: res.data.propertyAnalysis || defaultData.propertyAnalysis,
          };

          setEvaluationData(cleaned);
          setFormData(cleaned);
        } else {
          setEvaluationData(defaultData);
        }
      } catch (err) {
        console.error("Error fetching evaluation data:", err);
        toast.error("Failed to load evaluation data");
        setError("Failed to load evaluation data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [loanId]);

  const openEditDialog = () => {
    setFormData(evaluationData || defaultData);
    setIsEditOpen(true);
  };

  const handleInputChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const saveEditedData = async () => {
    try {
      const response = await evaluationAPI.saveEvaluationData(
        loanId,
        customerId,
        formData
      );

      if (response.success) {
        toast.success("Evaluation data updated successfully!");
        setEvaluationData(formData);
        setIsEditOpen(false);
      } else {
        toast.error("Failed to update evaluation data");
      }
    } catch (error) {
      console.error("Error saving evaluation data:", error);
      toast.error(`${error}`);
    }
  };

  if (error)
    return (
      <div className="bg-[#131313] rounded-lg p-4 mb-4 text-red-500 text-center">
        {error}
      </div>
    );

  const data = evaluationData || defaultData;

  return (
    <div className="bg-[#131313] rounded-lg p-4 mb-4 text-white">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg">Evaluation Scorecard</h3>
        <button
          onClick={openEditDialog}
          className="text-[#FFCA20] flex items-center gap-1 hover:text-yellow-300 transition-colors"
        >
          <Edit className="w-4 h-4" /> Edit Values
        </button>
      </div>

      {/* Four Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <SectionCard title="INCOME ANALYSIS" data={data.incomeAnalysis} />
        <SectionCard title="LEGAL ANALYSIS" data={data.legalAnalysis} />
        <SectionCard title="BUSINESS ANALYSIS" data={data.businessAnalysis} />
        <SectionCard title="PROPERTY ANALYSIS" data={data.propertyAnalysis} />
      </div>

      {/* ✅ EDIT POPUP */}
      {isEditOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 overflow-y-auto">
          <div className="bg-[#1e1e1e] p-6 rounded-lg w-[90%] max-w-2xl max-h-[90vh] overflow-y-auto">
            <h2 className="text-xl mb-4 text-[#FFCA20] font-semibold">
              Edit Evaluation Values
            </h2>

            {/* ✅ Only loop through analysis sections */}
            {Object.entries(formData).map(([section, fields]) => (
              <div key={section} className="mb-5 border-b border-gray-700 pb-3">
                <h3 className="text-lg mb-2 text-yellow-400 capitalize">
                  {section.replace("Analysis", " Analysis")}
                </h3>
                {Object.entries(fields).map(([field, value]) => (
                  <div key={field} className="mb-2">
                    <label className="block text-sm text-gray-400 mb-1 capitalize">
                      {field.replace(/([A-Z])/g, " $1")}
                    </label>
                    <input
                      type="text"
                      value={value || ""}
                      onChange={(e) =>
                        handleInputChange(section, field, e.target.value)
                      }
                      className="w-full bg-[#2c2c2c] text-white rounded p-2 focus:outline-none"
                    />
                  </div>
                ))}
              </div>
            ))}

            <div className="flex justify-end gap-3 mt-4">
              <button
                onClick={() => setIsEditOpen(false)}
                className="bg-gray-600 px-4 py-2 rounded hover:bg-gray-700"
              >
                Cancel
              </button>
              <button
                onClick={saveEditedData}
                className="bg-[#FFCA20] text-black px-4 py-2 rounded font-semibold hover:bg-yellow-400"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const SectionCard = ({ title, data }) => (
  <div className="border border-[#333333] rounded-lg p-4">
    <p className="text-gray-400 text-sm mb-1">{title}</p>
    <p className="text-white text-2xl font-bold mb-3">
      {!data.score ? "-/100" : `${data.score}/100`}
    </p>
    {Object.entries(data)
      .filter(([key]) => key !== "score")
      .map(([key, value]) => (
        <div key={key} className="flex justify-between text-sm mb-1">
          <span className="text-gray-400 capitalize">
            {key.replace(/([A-Z])/g, " $1")}
          </span>
          <span className="text-[#FFCA20]">{value || "-"}</span>
        </div>
      ))}
  </div>
);

export default EvaluationScoreBoard;
